const ToursOverview = ({ children }) => {
    return (
      <main className='main'>
        <div className='card-container'>{children}</div>
      </main>
    );
  };
  
  export default ToursOverview;
  